import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, ArrowUpRight } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";
import { api } from "../lib/api";
import Reveal from "../components/Reveal";

const CATS = ["All", "Social Media", "PR", "Web", "AI", "Strategy"];

const Blog = () => {
  const { lang, t } = useLang();
  const [posts, setPosts] = useState([]);
  const [cat, setCat] = useState("All");
  const [q, setQ] = useState("");

  useEffect(() => {
    const params = {};
    if (cat !== "All") params.category = cat;
    if (q) params.q = q;
    api.get("/blog", { params }).then(({ data }) => setPosts(data)).catch(() => {});
  }, [cat, q]);

  return (
    <div data-testid="blog-page">
      <section className="section-pad" style={{ paddingTop: "clamp(160px, 18vw, 220px)" }}>
        <div className="font-mono line-deco" style={{ fontSize: "0.75rem", letterSpacing: "0.2em", color: "var(--gold)", textTransform: "uppercase", marginBottom: 32 }}>
          {t.blog.label}
        </div>
        <h1 className="font-display" style={{ fontSize: "clamp(3rem, 8vw, 7rem)", fontWeight: 300, lineHeight: 1, color: "var(--warm-off-white)", letterSpacing: "-0.02em" }}>
          {t.blog.title}
        </h1>
      </section>

      <section className="section-pad" style={{ paddingTop: 0 }}>
        <div className="flex flex-wrap items-center justify-between" style={{ gap: 24, marginBottom: 48, borderBottom: "1px solid rgba(248,244,240,0.08)", paddingBottom: 24 }}>
          <div className="flex flex-wrap" style={{ gap: 8 }}>
            {CATS.map((c) => (
              <button
                key={c}
                data-testid={`blog-filter-${c.toLowerCase().replace(/\s/g, "-")}`}
                onClick={() => setCat(c)}
                className="font-mono"
                style={{
                  background: "transparent", border: "1px solid", borderColor: cat === c ? "var(--gold)" : "rgba(248,244,240,0.15)",
                  color: cat === c ? "var(--gold)" : "rgba(248,244,240,0.7)",
                  padding: "10px 18px", textTransform: "uppercase", letterSpacing: "0.15em", fontSize: "0.7rem", cursor: "pointer",
                }}
              >
                {c === "All" ? t.blog.all : c}
              </button>
            ))}
          </div>
          <div className="flex items-center" style={{ gap: 8, minWidth: 260, borderBottom: "1px solid rgba(248,244,240,0.2)", paddingBottom: 8 }}>
            <Search size={16} color="rgba(248,244,240,0.45)" />
            <input data-testid="blog-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder={t.blog.search} style={{ background: "transparent", border: "none", outline: "none", color: "var(--warm-off-white)", flex: 1, fontFamily: "inherit" }} />
          </div>
        </div>

        {posts.length === 0 ? (
          <p style={{ color: "rgba(248,244,240,0.6)" }}>{t.blog.empty}</p>
        ) : (
          <div className="grid" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: 32 }}>
            {posts.map((p, i) => (
              <Reveal key={p.id} delay={(i % 3) * 80}>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} style={{ textDecoration: "none", display: "block" }}>
                  <article style={{ position: "relative" }}>
                    <div style={{ overflow: "hidden", aspectRatio: "16/10" }}>
                      <img src={p.featured_image} alt="" loading="lazy" style={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.8s var(--ease-cinema)", filter: "brightness(0.85)" }} onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.06)")} onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")} />
                    </div>
                    <div style={{ marginTop: 20 }}>
                      <span className="font-mono" style={{ fontSize: "0.7rem", letterSpacing: "0.18em", color: "var(--gold)", textTransform: "uppercase" }}>{p.category}</span>
                      <h3 className="font-display" style={{ fontSize: "1.5rem", fontWeight: 400, color: "var(--warm-off-white)", marginTop: 10, lineHeight: 1.2 }}>
                        {lang === "tr" ? p.title_tr : p.title_en}
                      </h3>
                      <p style={{ color: "rgba(248,244,240,0.6)", lineHeight: 1.6, marginTop: 12, fontSize: "0.95rem" }}>{lang === "tr" ? p.excerpt_tr : p.excerpt_en}</p>
                      <div className="flex items-center" style={{ gap: 8, marginTop: 16, color: "var(--gold-light)" }}>
                        <span className="font-mono" style={{ fontSize: "0.75rem", letterSpacing: "0.15em" }}>{t.blog.readMore}</span>
                        <ArrowUpRight size={14} />
                      </div>
                    </div>
                  </article>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default Blog;
